export default class Revealer {
    constructor(element) {
        this.trigger = typeof (element) === 'string' ? document.querySelector(element) : element;
        this.container = this.trigger.parentNode.querySelector('.reveal-container');
        this.items = Array.from(this.container.querySelectorAll('.reveal-target'));
    }

    init() {
        this.trigger.addEventListener('click', this.reveal.bind(this));
    }

    reveal() {
        var startHeight = this.container.clientHeight;
        this.items.forEach(item => {
            item.classList.remove('reveal-target');
        });
        gsap.timeline()
            .set(this.trigger, { display: 'none' })
            .fromTo(this.container, { height: startHeight }, { height: this.container.clientHeight, duration: .6 });

    }
}